import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizOptions from "../shared/QuizOptions";
import BackgroundVideo from "../shared/BackgroundVideo";
import PromotionContent from "../shared/PromotionContent";
import { VIDEO_URLS } from "../../utils/videoConfig";

const GENDER_TEXT_MAP = {
  woman: "Women",
  man: "Men",
  other: "People",
};

const AGE_TEXT_MAP = {
  "18-24": "in their 20s",
  "25-35": "in their 30s",
  "35-44": "in their 40s",
  "45+": "over 40",
};

const Step2 = ({ onContinue, answers }) => {
  const getDynamicText = () => {
    const genderAnswer = answers.welcome;
    const ageAnswer = answers.age;

    const genderText = GENDER_TEXT_MAP[genderAnswer] || "People";
    const ageText = AGE_TEXT_MAP[ageAnswer] || "";

    if (genderText && ageText) {
      return `${genderText} ${ageText}`;
    }

    return genderText || ageText || "People";
  };

  return (
    <QuizContent>
      <QuizOptions>
        <BackgroundVideo src={VIDEO_URLS.video1} />
        <PromotionContent onContinue={onContinue}>
          <h2>
            <strong>
              <span className="dynamic">{getDynamicText()}</span> are leading
              interest for AI, quickly adopting new tech, such as AI
              companionship
            </strong>
          </h2>
        </PromotionContent>
      </QuizOptions>
    </QuizContent>
  );
};

export default Step2;
